import { MarkdownBody } from "@hamlak/ui";

/** text{body}: 마크다운 본문(채팅과 같은 파서). 기호 없는 문단은 일반 본문, `*…*` 는 회색 지문, 굵게·목록·제목 등 표시. */
export function TextBlock({ body }: { body: string }) {
  return (
    <div className="block block--text" data-testid="block-text">
      <MarkdownBody text={body} plain />
    </div>
  );
}
